import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createLoggedAgentsAdminsPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            value: 'select',
            key: 'select',
            align: 'center',
            sortable: false,
            minWidth: 26,
            width: 26,
            cellProps: { class: 'px-0' },
            headerProps: { class: 'px-0' },
        },
        {
            title: t('loggedAgentsAdmins.connectionId'),
            value: 'connectionId',
            key: 'connectionId',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.appId'),
            value: 'uniqAppId',
            key: 'uniqAppId',
            align: 'start',
            sortable: true,
            cellProps: { class: 'nowrap' },
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.userName'),
            value: 'userLogin',
            key: 'userLogin',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.role'),
            value: 'userTypeId',
            key: 'userTypeId',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.ip'),
            value: 'ip',
            key: 'ip',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.os'),
            value: 'os',
            key: 'os',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.browser'),
            value: 'browser',
            key: 'browser',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.pageUrl'),
            value: 'pageUrl',
            key: 'pageUrl',
            align: 'start',
            sortable: true,
            nowrap: true,
            headerProps: { class: 'nowrap' },
            cellProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.sessionStartedAt'),
            value: 'startAt',
            key: 'startAt',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedAgentsAdmins.updatedAt'),
            value: 'updateUserDate',
            key: 'updateUserDate',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
    ];
}
